/* トップページの動き。
   ・メイン画像（写真・文字・丸ボタン）の切り替え
   ・切り替わった写真に合わせて、下の入口（左右2分割）を光らせる
   ・STAFF RECOMMEND の自動送り                                        */

var bgs = document.querySelectorAll('.hbg'),
    dots = document.querySelectorAll('.hdot'),
    txs = document.querySelectorAll('.ht'),
    ents = document.querySelectorAll('.auda-c'),
    i = 0, timer = null, warmTimer = null, heroRequest = 0,
    reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

/* メイン画像の順番（1枚目はMISSION）と、入口の順番を対応させる。
   2枚目＝1つめの入口、3枚目＝2つめ…という数え方。 */
function mark(n) {
  if (!ents.length) return;
  ents.forEach(function (c, k) { c.classList.toggle('is-hl', k === n - 1); });
}

/* data-src を持つ画像は、必要になった1枚だけ読み込む。 */
function fillHero(n) {
  if (!bgs.length) return null;
  var el = bgs[(n + bgs.length) % bgs.length];
  if (window.AUGHero && typeof window.AUGHero.fill === 'function') {
    window.AUGHero.fill(el);
  } else if (el && !el.getAttribute('data-aug-hero-filled')) {
    el.setAttribute('data-aug-hero-filled', '1');
    var ss = el.getAttribute('data-srcset');
    var s = el.getAttribute('data-src');
    if (ss) el.setAttribute('srcset', ss);
    if (s) el.setAttribute('src', s);
  }
  return el;
}

/* 6秒の切替より1.5秒早く、次の1枚だけを先読みする。 */
function warmNext() {
  clearTimeout(warmTimer);
  warmTimer = setTimeout(function () { fillHero(i + 1); }, 4500);
}

function showHero(n) {
  if (n === i || !bgs.length) return;
  bgs[i].classList.remove('is-on');
  i = n;
  var el = bgs[i];
  el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
  el.classList.add('is-on');
  dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
  txs.forEach(function (x, k) {
    var on = k === i;
    x.classList.toggle('is-on', on);
    /* 見えていないスライドの文字を、読み上げソフトとタブ移動から外す。
       CSSの opacity:0 だけだと、隠れている文章まで読み上げられてしまう。 */
    x.setAttribute('aria-hidden', on ? 'false' : 'true');
    x.querySelectorAll('a, button').forEach(function (f) {
      if (on) { f.removeAttribute('tabindex'); } else { f.setAttribute('tabindex', '-1'); }
    });
  });
  mark(i);
  warmNext();
}

function go(n) {
  if (!bgs.length) return;
  var target = (n + bgs.length) % bgs.length;
  var request = ++heroRequest;
  if (target === i) { warmNext(); return; }

  var el = fillHero(target);
  var reveal = function () {
    if (request !== heroRequest) return;
    showHero(target);
  };

  /* 未読込のドットを直接押した場合は、今の写真を残したまま読込完了を待つ。 */
  if (!el || (el.complete && el.naturalWidth > 0)) {
    reveal();
  } else {
    el.addEventListener('load', reveal, { once: true });
    el.addEventListener('error', function () {
      if (request === heroRequest) warmNext();
    }, { once: true });
  }
}

function start() {
  clearInterval(timer);
  timer = null;
  if (reduceMotion && reduceMotion.matches) return;
  timer = setInterval(function () { go(i + 1); }, 6000);
}

if (reduceMotion) {
  var onMotionChange = function (event) {
    if (event.matches) {
      clearInterval(timer);
      timer = null;
    } else {
      start();
    }
  };
  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', onMotionChange);
  } else if (reduceMotion.addListener) {
    reduceMotion.addListener(onMotionChange);
  }
}

dots.forEach(function (d, k) {
  d.addEventListener('click', function (e) { e.preventDefault(); go(k); start(); });
});

/* 最初の1枚以外は、はじめから支援技術の対象外にしておく */
txs.forEach(function (x, k) { x.setAttribute('aria-hidden', k === 0 ? 'false' : 'true'); });

mark(i);
warmNext();
start();

/* STAFF RECOMMEND
   ・自動送り：1枚ずつ左へ送り、送り終えた1枚を末尾に回して無限に続ける
   ・指（マウス）で左右にも動かせる（v474で追加）

   指で動かすときの考え方：
   　止まっているときの並びは「先頭の札が左端、ずれ0」です。
   　この状態からは右方向（＝前の札）に動かす余地がありません。
   　そこで触れた瞬間に、末尾の札を先頭に move して、ずれを1枚分ぶん
   　左にしておきます。見た目は動かないまま、左右どちらにも
   　1枚分の余裕がある状態になります。
   　あとは指の動きに合わせてずらし、離したときに
   　　左へ大きく動かした → 次の札へ
   　　右へ大きく動かした → 前の札へ
   　　少しだけ → 元の位置に戻す
   　のどれかに寄せます。寄せ終わったあとに並びを整えるので、
   　途中の状態が画面に出ることはありません。                        */
(function () {
  var vp = document.querySelector('.sts-vp'), row = document.querySelector('.sts');
  if (!vp || !row) return;

  var MOVE = 1500;      /* 自動送りの動く時間 */
  var WAIT = 2600;      /* 自動送りの間隔 */
  var SNAP = 320;       /* 指を離したあとに寄せる時間 */
  var RESUME = 5000;    /* 指で操作したあと、自動送りを再開するまで */
  var t = null, resumeT = null, busy = false;
  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduce = !!(reduceQuery && reduceQuery.matches);

  function stepWidth() {
    var first = row.firstElementChild;
    if (!first) return 0;
    var gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) || 20;
    return Math.round(first.getBoundingClientRect().width + gap);
  }

  /* 位置を指定する。
     aug-top-page.css に
       .augt .sts { transform: translate3d(0,0,0) !important; }
     という指定があり、!important が付いているため、
     ふつうの row.style.transform では上書きできません
     （実機で計測したところ、transform はずっと0のままでした。
     　これまでの自動送りが「すべる」ではなく「一瞬で切り替わる」
     　動きになっていたのはこれが原因です）。
     そこで setProperty で important を付けて指定します。 */
  function setX(x, ms) {
    row.style.setProperty('transition', ms ? ('transform ' + ms + 'ms cubic-bezier(.45,.05,.2,1)') : 'none', 'important');
    row.style.setProperty('transform', 'translate3d(' + x + 'px,0,0)', 'important');
  }

  /* 指定の位置まで動かし、動き終わったら after() で並びを整える */
  function glide(x, ms, after) {
    var done = function (e) {
      if (e && e.target !== row) return;
      row.removeEventListener('transitionend', done);
      clearTimeout(guard);
      row.style.setProperty('transition', 'none', 'important');
      if (after) after();
      row.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
      row.getBoundingClientRect();
      busy = false;
    };
    row.addEventListener('transitionend', done);
    var guard = setTimeout(done, ms + 400);
    requestAnimationFrame(function () { setX(x, ms); });
  }

  /* 自動送り（止まっている状態からの1枚送り） */
  function step() {
    if (busy || dragging) return;
    busy = true;
    var first = row.firstElementChild;
    glide(-stepWidth(), MOVE, function () { row.appendChild(first); });
  }

  function run() { clearInterval(t); if (!reduce) t = setInterval(step, WAIT); }
  function pause() { clearInterval(t); clearTimeout(resumeT); }
  function laterRun() { clearTimeout(resumeT); resumeT = setTimeout(run, RESUME); }

  if (reduceQuery) {
    var onReduceChange = function (event) {
      reduce = event.matches;
      if (reduce) {
        pause();
      } else {
        run();
      }
    };
    if (reduceQuery.addEventListener) {
      reduceQuery.addEventListener('change', onReduceChange);
    } else if (reduceQuery.addListener) {
      reduceQuery.addListener(onReduceChange);
    }
  }

  /* ---- ここから指での操作 ---- */
  var dragging = false, startX = 0, startY = 0, dx = 0, w = 0, moved = false, lifted = null, id = null;

  function begin(x, y) {
    if (busy) return false;
    pause();
    w = stepWidth();
    if (!w) return false;
    /* 末尾の札を先頭に回し、見た目を変えずに1枚分の余裕をつくる */
    lifted = row.lastElementChild;
    row.style.setProperty('transition', 'none', 'important');
    row.insertBefore(lifted, row.firstElementChild);
    setX(-w, 0);
    row.getBoundingClientRect();
    dragging = true; moved = false; startX = x; startY = y; dx = 0;
    return true;
  }

  function move(x) {
    dx = x - startX;
    if (Math.abs(dx) > 8) moved = true;
    var pos = -w + dx;
    if (pos > 0) pos = 0;                 /* 1枚分より先には動かさない */
    if (pos < -w * 2) pos = -w * 2;
    setX(pos, 0);
  }

  function end() {
    if (!dragging) return;
    dragging = false;
    busy = true;
    var TH = Math.min(70, w * 0.18);      /* この距離を超えたら1枚送る */
    var back = lifted;
    if (dx <= -TH) {
      /* 次の札へ。先頭2枚（回した札と元の先頭）を末尾へ戻す */
      var first = row.firstElementChild, second = first && first.nextElementSibling;
      glide(-w * 2, SNAP, function () {
        if (first) row.appendChild(first);
        if (second) row.appendChild(second);
      });
    } else if (dx >= TH) {
      /* 前の札へ。回した札をそのまま先頭として残す */
      glide(0, SNAP, null);
    } else {
      /* 元に戻す。回した札を末尾へ返す */
      glide(-w, SNAP, function () { if (back) row.appendChild(back); });
    }
    lifted = null;
    laterRun();
  }

  /* 画像を掴んだときのブラウザ標準のドラッグを止める */
  row.addEventListener('dragstart', function (e) { e.preventDefault(); });

  if (window.PointerEvent) {
    /* v620：カードを1回クリックしても商品ページへ移動しない不具合を直す。

       これまでは、指やマウスが触れた瞬間（pointerdown）に
       　・札の並べ替え（末尾の札を先頭へ回す）
       　・そのポインタの捕捉（setPointerCapture）
       の両方をしていました。捕捉すると、そのあとのクリックは
       札のリンクではなく枠（.sts-vp）に届くため、
       ただ押しただけではリンクが開きませんでした。

       触れた時点では何もせず、横に8px以上動いてはじめて
       「送るつもりの操作」と見なして、並べ替えと捕捉を始めます。
       押しただけならリンクはそのまま開きます。
       縦に動かしたときは何もしないので、ページのスクロールも妨げません。 */
    var pending = false, downX = 0, downY = 0;

    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (busy) return;
      moved = false;
      pending = true;
      downX = e.clientX;
      downY = e.clientY;
      id = e.pointerId;
      pause();
    });
    vp.addEventListener('pointermove', function (e) {
      if (e.pointerId !== id) return;
      if (pending) {
        var ax = Math.abs(e.clientX - downX), ay = Math.abs(e.clientY - downY);
        if (ax < 8) return;                                   /* まだ送る操作とは見なさない */
        if (ay > ax) { pending = false; id = null; laterRun(); return; }  /* 縦の動き＝ページのスクロール */
        pending = false;
        if (!begin(downX, downY)) { id = null; laterRun(); return; }
        try { vp.setPointerCapture(id); } catch (err) {}
      }
      if (!dragging) return;
      move(e.clientX);
    });
    var up = function (e) {
      if (e.pointerId !== id) return;
      if (pending) {                      /* 動かしていない＝ただのクリック。何もしない */
        pending = false;
        id = null;
        laterRun();
        return;
      }
      try { vp.releasePointerCapture(id); } catch (err) {}
      id = null;
      end();
    };
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);
  } else {
    /* 古いブラウザ向け */
    vp.addEventListener('touchstart', function (e) {
      var p = e.touches[0]; if (!p) return;
      begin(p.clientX, p.clientY);
    }, { passive: true });
    vp.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var p = e.touches[0]; if (!p) return;
      /* 横に動かしているときだけ、縦スクロールを止める */
      if (Math.abs(p.clientX - startX) > Math.abs(p.clientY - startY) && e.cancelable) e.preventDefault();
      move(p.clientX);
    }, { passive: false });
    vp.addEventListener('touchend', end);
    vp.addEventListener('touchcancel', end);
  }

  /* 動かした直後は、札のリンクを開かない（送るつもりの操作で移動しないように） */
  vp.addEventListener('click', function (e) {
    if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);

  run();
})();
